import Vue from 'vue'
import Router from 'vue-router'

import AppWrap from '@/pages/AppWrap'
import LandingPage from '@/pages/Landing'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: AppWrap,
      props: { mode: 'login' }
    },
    {
      path: '/me',
      name: 'DashboardPage',
      component: AppWrap,
      props: { mode: 'dashboard' }
    },
    {
      path: '/get/:type',
      name: 'GetProPage',
      component: AppWrap,
      props: { mode: 'getpro' }
    },
    {
      path: '/post/:postid',
      name: 'DashboardPostPage',
      component: AppWrap,
      props: { mode: 'dashboard' }
    },
    {
      path: '/add/:type',
      name: 'AddProductPage',
      component: AppWrap,
      props: { mode: 'add-product' }
    },
    {
      path: '/add/:type/:id',
      name: 'AddProductPage',
      component: AppWrap,
      props: { mode: 'add-product' }
    },
    {
      path: '/add-template',
      name: 'AddProductPage',
      component: AppWrap,
      props: { mode: 'add-template' }
    },
    {
      path: '/previous',
      name: 'PreviousCuppingsPage',
      component: AppWrap,
      props: { mode: 'previous' }
    },
    {
      path: '/products',
      name: 'ProductsPage',
      component: AppWrap,
      props: { mode: 'products' }
    },
    {
      path: '/coffees',
      name: 'CoffeesPage',
      component: AppWrap,
      props: { mode: 'coffees' }
    },
    {
      path: '/templates',
      name: 'TemplatesPage',
      component: AppWrap,
      props: { mode: 'templates' }
    },
    {
      path: '/templates/:templateid',
      name: 'TemplatePage',
      component: AppWrap,
      props: { mode: 'template' }
    },
    {
      path: '/live/:liveSessionId',
      name: 'LivePage',
      component: AppWrap,
      props: { mode: 'live2' }
    },
    {
      path: '/live/:liveSessionId/:parts',
      name: 'LivePage',
      component: AppWrap,
      props: { mode: 'live2' }
    },
    {
      path: '/live',
      name: 'LivePage',
      component: AppWrap,
      props: { mode: 'live' }
    },
    {
      path: '/sessions',
      name: 'SessionsPage',
      component: AppWrap,
      props: { mode: 'sessions' }
    },
    {
      path: '/cupping',
      name: 'CuppingPage',
      component: AppWrap,
      props: { mode: 'cupping' }
    },
    {
      path: '/live2',
      name: 'LivePage',
      component: AppWrap,
      props: { mode: 'live2' }
    },
    {
      path: '/live3',
      name: 'LivePage',
      component: AppWrap,
      props: { mode: 'live3' }
    },
    {
      path: '/settings',
      name: 'SettingsPage',
      component: AppWrap,
      props: { mode: 'settings' }
    },
    {
      path: '/host',
      name: 'HostPage',
      component: AppWrap,
      props: { mode: 'host' }
    },
    {
      path: '/feel',
      name: 'ProductPage',
      component: AppWrap,
      props: { mode: 'product' }
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: AppWrap,
      props: { mode: 'login' }
    },
    {
      path: '/pro',
      name: 'ProPage',
      component: AppWrap,
      props: { mode: 'login' }
    },
    {
      path: '/contact',
      name: 'LoginPage',
      component: AppWrap,
      props: { mode: 'contact' }
    },
    {
      path: '/privacy',
      name: 'LoginPage',
      component: AppWrap,
      props: { mode: 'privacy' }
    },
    {
      path: '/terms',
      name: 'LoginPage',
      component: AppWrap,
      props: { mode: 'terms' }
    },
    {
      path: '/account',
      name: 'AccountPage',
      component: AppWrap,
      props: { mode: 'account' }
    },
    {
      path: '/faq',
      name: 'FaqPage',
      component: AppWrap,
      props: { mode: 'faq' }
    },
    {
      path: '/500',
      name: 'Forbidden',
      component: AppWrap,
      props: { mode: 'forbidden' }
    },
    {
      path: '/404',
      name: 'NotFound',
      component: AppWrap,
      props: { mode: 'notFound' }
    },
    {
      path: '*',
      redirect: '/404'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js